function isSameLocalDate(left: Date, right: Date) {
  return (
    left.getFullYear() === right.getFullYear() &&
    left.getMonth() === right.getMonth() &&
    left.getDate() === right.getDate()
  );
}

export function formatSessionActivityAt(
  value: string,
  now: Date = new Date()
): string {
  const activityAt = new Date(value);
  if (Number.isNaN(activityAt.getTime())) return "";

  const time = new Intl.DateTimeFormat("ja-JP", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(activityAt);
  if (isSameLocalDate(activityAt, now)) return time;

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (isSameLocalDate(activityAt, yesterday)) return `昨日 ${time}`;

  if (activityAt.getFullYear() === now.getFullYear()) {
    return `${activityAt.getMonth() + 1}/${activityAt.getDate()}`;
  }

  return `${activityAt.getFullYear()}/${activityAt.getMonth() + 1}/${activityAt.getDate()}`;
}

export function formatSessionActivityTitle(value: string): string {
  const activityAt = new Date(value);
  if (Number.isNaN(activityAt.getTime())) return "最終更新日時不明";

  return `最終更新：${new Intl.DateTimeFormat("ja-JP", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(activityAt)}`;
}
